<div
  *cdkDragPlaceholder
  class="p-3 my-2 form-field-placeholder field-type-item position-relative"
  [ngClass]="fieldType().containerClass"
>
  <ng-icon
    class="icon"
    [name]="fieldType().icon"
    size="1.125rem"
  ></ng-icon>

  <span
    class="ms-2"
    translate
    >{{ fieldType().label }}</span
  >

  <div class="position-indicator">
    <div class="circle-start"></div>
    <div class="line"></div>
    <div class="circle-end"></div>
  </div>
</div>
